// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"259":"25b55031","462":"7992ebd8","494":"1bc6b304"}[chunkId] + ".chunk.css";
};